import axios from "axios";
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// EMPLOYEE CTC RELATED APIs
// ==============================================

// 1. Get CTC Employee Cost Centers
export const getCTCEmpCostCenter = async () => {
    try {
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/HR/GetCTCEmpCostCenter`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 2. Get Employee CTC by Cost Center
export const getEmployeeCTCbyCC = async (ccCode) => {
    try {
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/HR/GETEmployeeCTCbyCC?CCCode=${ccCode}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 3. Get Employee CTC by Employee Reference Number
export const getEmployeeCTCbyEmp = async (emprefNo) => {
    try {
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/HR/GETEmployeeCTCbyEmp?Emprefno=${emprefNo}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 4. Get Employee CTC for Report
export const getEmpCTCforReport = async (params) => {
    try {
        const { empRefNo, revisionNo } = params;
         // DEBUG
        
        const queryParams = new URLSearchParams({
            EmpRefNo: empRefNo || '',
            RevisionNo: revisionNo || ''
        });
        
        const response = await axios.get(
            `${API_BASE_URL}/HR/GetEmpCTCforReport?${queryParams}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 5. Get Auto Complete CTC Employee
export const getAutoCompleteCTCEmp = async (prefix) => {
    try {
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/HR/GetAutoCompleteCTCEmp?Prefix=${prefix}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};